<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      class="ag-theme-balham ag-grid-listado-categorias-equivalentes"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColDef"
      :rowSelection="rowSelection"
      :pagination="pagination"
      :rowClassRules="rowClassRules"
      :columnDefs="columnDefs"
      :rowData="rowData"
      @grid-ready="onGridReady"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../../mixins/listado-ag-grid.mixin';
import { MONEDAS_TEXTOS } from '../../utils/constantes';
import { cellRendererNumeroRegistro } from '../../utils/funciones';

export default {
  name: 'ListadoCategoriasEquivalentes',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'MONEDA',
          field: 'moneda',
          cellRenderer: (params) => {
            return MONEDAS_TEXTOS[params.data.moneda];
          },
          valueGetter: (params) => {
            return MONEDAS_TEXTOS[params.data.moneda];
          },
          filter: true,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'CANTIDAD',
          field: 'cantidad',
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'CATEGORÍA',
          field: 'categoria.nombre',
          minWidth: 200,
        },
        {
          headerName: 'EQUIVALENCIA',
          field: 'equivalencia',
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'PLAN COBRO PROGRAMA',
          field: 'nombrePlanCobroPrograma',
          cellRenderer: (params) => {
            return params.data?.nombrePlanCobroPrograma || '-';
          },
          minWidth: 220,
        },
        {
          headerName: 'CATEGORÍA EQUIVALENTE',
          field: 'categoriaEquivalente.nombre',
          minWidth: 200,
        },
        {
          headerName: 'INSTITUCIÓN',
          field: 'institucion.nombre',
          filter: false,
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-categorias-equivalentes {
  height: calc(var(--vh, 1vh) * 100 - 17rem);
}
</style>
  